var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "theProductListFilters", class: [_vm.bemBlock, "header-popup"] },
    [
      _c("div", { class: [_vm.bemElement("header")] }, [
        _c(
          "span",
          {
            class: [
              _vm.bemElement("filters-count-text"),
              _vm.bemElement("header-text")
            ]
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$msg("filters.quantity.text", "filters", [
                    _vm.uiNumSelectedFilters
                  ])
                ) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            class: [
              _vm.bemElement("filters-clear-all"),
              _vm.bemElement("header-text"),
              "u-btn-clean"
            ],
            on: {
              click: function($event) {
                _vm.productSearch && _vm.handleClearAllClick()
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$msg("filters.clearall.text", "filters")) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [
            _vm.bemElement("btn-close"),
            "header-popup__btn-close",
            "btn-close",
            "u-btn-clean"
          ],
          on: { click: _vm.sendAnalyticsEventClosed }
        },
        [
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$msg("global.close", "locale")) + "\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("BaseFiltersSorting", {
        attrs: {
          loading: _vm.loading,
          options: _vm.sortingOptions,
          selected: _vm.selectedSortingOption
        },
        on: { select: _vm.selectSortingOption }
      }),
      _vm._v(" "),
      _c("BaseFiltersSize", {
        attrs: {
          loading: _vm.loading,
          refinement: _vm.sizeRefinement,
          selected: _vm.selectedFilters
        },
        on: { select: _vm.selectFilter, deselect: _vm.deselectFilter }
      }),
      _vm._v(" "),
      _c("BaseFiltersColor", {
        attrs: {
          loading: _vm.loading,
          refinement: _vm.colorRefinement,
          selected: _vm.selectedFilters
        },
        on: { select: _vm.selectFilter, deselect: _vm.deselectFilter }
      }),
      _vm._v(" "),
      !_vm.isGlobaleEnabled
        ? _c("BaseFiltersPrice", {
            attrs: {
              loading: _vm.loading,
              refinement: _vm.priceRefinement,
              selected: _vm.selectedFilters
            },
            on: { select: _vm.selectFilter, deselect: _vm.deselectPriceFilter }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.applyFiltersDirectly
        ? _c(
            "button",
            {
              class: [
                _vm.bemElement("btn-apply"),
                "btn",
                {
                  "btn--primary": _vm.isBreakpointDesktop,
                  "btn--cta": _vm.isBreakpointMobile
                }
              ],
              on: {
                click: function($event) {
                  _vm.productSearch && _vm.handleApplyClick()
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$msg("filters.button.apply", "filters")) +
                  "\n  "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }